import { createContext, useContext } from 'react';

interface PageTitleContext {
  setFaviconUrl: (_: string) => void;
  setFeature: (_: string) => void;
  setRestaurant: (_: string) => void;
}

export const PageTitleContext = createContext<PageTitleContext | null>(null);

export const usePageTitle = () => {
  const context = useContext(PageTitleContext);
  if (context == null) {
    throw new Error('usePageTitle must be used within PageTitleProvider');
  }

  return context;
};
